import React, { Dispatch, createContext, SetStateAction, useContext, useState } from 'react';
import { ChildrenProps } from '../../../../../types/common';
import { TariffName, TariffOperator } from '../../channel-details/optimizer/configuration/types/tariff-kind';

type DashboardProviderState = {
  tariff: TariffName | null;
  setTariff: Dispatch<SetStateAction<TariffName | null>>;
  tariffOperator: TariffOperator | null;
  setTariffOperator: Dispatch<SetStateAction<TariffOperator | null>>;
  hoursExpanded: boolean;
  toggleHoursExpanded: () => void;
};

const initialState: DashboardProviderState = {
  tariff: null,
  setTariff: () => null,
  tariffOperator: null,
  setTariffOperator: () => null,
  hoursExpanded: false,
  toggleHoursExpanded: () => null,
};

export const DashboardContext = createContext<DashboardProviderState>(initialState);

export const useDashboardContext = (): DashboardProviderState => useContext(DashboardContext);

export const DashboardContextProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [tariff, setTariff] = useState<TariffName | null>(null);
  const [tariffOperator, setTariffOperator] = useState<TariffOperator | null>(null);
  const [hoursExpanded, setHoursExpanded] = useState<boolean>(false);

  const toggleHoursExpanded = () => {
    setHoursExpanded((prev) => !prev);
  };

  const values: DashboardProviderState = {
    tariff,
    setTariff,
    tariffOperator,
    setTariffOperator,
    hoursExpanded,
    toggleHoursExpanded,
  };

  return <DashboardContext.Provider value={values}>{children}</DashboardContext.Provider>;
};
